// extracted by mini-css-extract-plugin
module.exports = {"horizontal":"theme__horizontal--1vZPj","vertical":"theme__vertical--1v_qN"};